import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Outlet, useLocation, useParams } from 'react-router-dom';
import routes from '@/routing/front';
import * as globalActions from '@/store/actions/globalAction';

export default function RouteManager(){
  const dispatch = useDispatch();
  const location = useLocation();
  const params = useParams();
  const [previousRoute, setPreviousRoute] = useState();

  useEffect(() => {
    if (location.pathname !== previousRoute) {
      dispatch(
        globalActions.setRoute({
          name: location.pathname,
          params,
        })
      );
      if (previousRoute !== location.pathname) {
        dispatch(globalActions.fetchPermissions(params));
        setPreviousRoute(location.pathname);
      }
    }
  }, [location]);

  return <Outlet />;
};

